// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Rect$SmartcutsMacros = require("../Rect.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");

function resizeOption_encode(v) {
  if (typeof v === "number") {
    return ["Original"];
  } else if (v.TAG === /* ResizeByScale */0) {
    return [
            "ResizeByScale",
            Decco.floatToJson(v._0)
          ];
  } else {
    return [
            "ResizeToFitWidthInPx",
            Decco.intToJson(v._0)
          ];
  }
}

function resizeOption_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Original" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Original */0
                  };
          }
      case "ResizeByScale" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ResizeByScale */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ResizeToFitWidthInPx" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ResizeToFitWidthInPx */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyResizeOption(resizeOption) {
  if (typeof resizeOption === "number") {
    return "Original";
  } else if (resizeOption.TAG === /* ResizeByScale */0) {
    return "ResizeByScale(" + (resizeOption._0.toString() + "x)");
  } else {
    return "ResizeToFitWidthInPx(" + (String(resizeOption._0) + "px)");
  }
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "clientRect",
                Rect$SmartcutsMacros.t_encode(v.clientRect)
              ],
              [
                "resizeOption",
                resizeOption_encode(v.resizeOption)
              ],
              [
                "size",
                Decco.floatToJson(v.size)
              ],
              [
                "hash",
                Decco.stringToJson(v.hash)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var clientRect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "clientRect"), null));
    if (clientRect.TAG === /* Ok */0) {
      var resizeOption = resizeOption_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resizeOption"), null));
      if (resizeOption.TAG === /* Ok */0) {
        var size = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
        if (size.TAG === /* Ok */0) {
          var hash = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hash"), null));
          if (hash.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      selector: selector._0,
                      clientRect: clientRect._0,
                      resizeOption: resizeOption._0,
                      size: size._0,
                      hash: hash._0
                    }
                  };
          }
          var e = hash._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".hash" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = size._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".size" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = resizeOption._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".resizeOption" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = clientRect._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".clientRect" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function stringify(param) {
  return "{ clientRect: " + (Rect$SmartcutsMacros.stringify(param.clientRect) + (", resizeOption: " + (stringifyResizeOption(param.resizeOption) + (", size: " + (param.size.toString() + (", hash: " + (StringUtils$SmartcutsMacros.quote(param.hash) + (" , selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + " }")))))))));
}

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "recordedClientRect",
                Rect$SmartcutsMacros.t_encode(v.recordedClientRect)
              ],
              [
                "resizeOption",
                resizeOption_encode(v.resizeOption)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var recordedClientRect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordedClientRect"), null));
    if (recordedClientRect.TAG === /* Ok */0) {
      var resizeOption = resizeOption_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resizeOption"), null));
      if (resizeOption.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selector: selector._0,
                  recordedClientRect: recordedClientRect._0,
                  resizeOption: resizeOption._0
                }
              };
      }
      var e = resizeOption._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".resizeOption" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = recordedClientRect._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".recordedClientRect" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromRecordingCommandValue(param) {
  return {
          selector: param.selector,
          recordedClientRect: param.clientRect,
          resizeOption: param.resizeOption
        };
}

function stringify$1(param) {
  return "{ resizeOption: " + (stringifyResizeOption(param.resizeOption) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + " }")));
}

function updateSelector(f, cmdVal) {
  return {
          selector: Curry._1(f, cmdVal.selector),
          recordedClientRect: cmdVal.recordedClientRect,
          resizeOption: cmdVal.resizeOption
        };
}

function getIdentifier(param) {
  return "screenshot:" + Selector$SmartcutsMacros.stringify(undefined, false, param.selector);
}

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromRecordingCommandValue: fromRecordingCommandValue,
  stringify: stringify$1,
  updateSelector: updateSelector,
  getIdentifier: getIdentifier
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "recordedClientRect",
                Rect$SmartcutsMacros.t_encode(v.recordedClientRect)
              ],
              [
                "resizeOption",
                resizeOption_encode(v.resizeOption)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var recordedClientRect = Rect$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordedClientRect"), null));
    if (recordedClientRect.TAG === /* Ok */0) {
      var resizeOption = resizeOption_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "resizeOption"), null));
      if (resizeOption.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  selector: selector._0,
                  recordedClientRect: recordedClientRect._0,
                  resizeOption: resizeOption._0
                }
              };
      }
      var e = resizeOption._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".resizeOption" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = recordedClientRect._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".recordedClientRect" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromAuthoring(param) {
  return {
          selector: param.selector,
          recordedClientRect: param.recordedClientRect,
          resizeOption: param.resizeOption
        };
}

function selectorGet(param) {
  return [param.selector];
}

function stringify$2(param) {
  return "{ resizeOption: " + (stringifyResizeOption(param.resizeOption) + (", selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + " }")));
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromAuthoring: fromAuthoring,
  selectorGet: selectorGet,
  stringify: stringify$2
};

var CommandValue = {
  resizeOption_encode: resizeOption_encode,
  resizeOption_decode: resizeOption_decode,
  stringifyResizeOption: stringifyResizeOption,
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

exports.CommandValue = CommandValue;
/* Rect-SmartcutsMacros Not a pure module */
